'use client';

import { Image, Typography } from '@/components/atoms';
import { LinkButton } from '@/components/molecules';
import { useBreakpoint } from '@/lib/hooks/util/useBreakpoint';

import { CTABannerProps } from './types';

export const CTABanner = ({
  imageUrl,
  title,
  href,
  description,
  altImage = 'Banner hero Image',
  primaryButtonText,
}: CTABannerProps) => {
  const isDesktop = useBreakpoint('sm');
  const chosenMedia = imageUrl.landscape
    ? isDesktop
      ? imageUrl.landscape.url
      : imageUrl.portrait.url
    : 'img';
  return (
    <div className="flex flex-col lg:flex-row justify-between w-full py-(--horizontal-spacing-5) px-(--horizontal-spacing-4) lg:p-(--horizontal-spacing-16) rounded-(--radius-xs) bg-(--color-surface-neutral-softer) gap-(--vertical-spacing-4) transition">
      <div className="w-full lg:w-1/3 aspect-square order-1 lg:order-2 justify-center items-center">
        <Image
          alt={altImage}
          src={chosenMedia}
          className="rounded-(--radius-xs) object-cover"
          aspectRatio="square"
        />
      </div>

      <div className="[align-items:var(--CTA-content-alignment,flex-start)] [text-align:var(--CTA-text-alignment)] flex flex-col justify-center gap-(--vertical-spacing-5) w-full lg:w-3/5 order-2 lg:order-1">
        <Typography.Heading variant="h6">{title}</Typography.Heading>
        <Typography.Text variant={'paragraph'} size={'lg'}>
          {description}
        </Typography.Text>
        <LinkButton href={href} size="md" className="w-full lg:w-fit">
          {primaryButtonText}
        </LinkButton>
      </div>
    </div>
  );
};
